import { render, staticRenderFns } from "./SimpleLink.vue?vue&type=template&id=e713f0ce&"
import script from "./SimpleLink.vue?vue&type=script&lang=js&"
export * from "./SimpleLink.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLink.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/opt/build/repo/storefront/components/atoms/Link/BaseLink.vue').default})
